const body = {
  borderLeft: '1px solid #e6e6e6',
  minHeight: '200px',
};

export default {
  body,
};



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Tabs/style.js